export const coachesFr = [
  {
    id: "auriane-de-potesta",
    name: "Auriane de POTESTA",
    role: "Associée Fondatrice",
    photo: "https://lirp.cdn-website.com/514d3088/dms3rep/multi/opt/IMG-20160414-WA0000jpg.0-bc9d18ea-1920w.jpg",
    short: "Associée Fondatrice d'Audace & Perspectives.",
    bio: [
      "Associée Fondatrice, Auriane a créé Audace & Perspectives en 2022. Elle accompagne avec engagement et pragmatisme des cadres supérieurs et dirigeants dans le développement et l'optimisation de leurs talents et ce, dans des entreprises où l'orientation clients et la notion de performance est sans cesse plus importante.",
      "Diplômée de l'ISC Bruxelles et IGS Paris, elle a débuté sa carrière à Bruxelles dans des sociétés anglo-saxonnes dans des directions commerciales, dans le management d'équipes, la mise en place, l'animation et le développement de réseaux de distribution. Elle a rejoint ensuite des cabinets de chasses de têtes où ses missions étaient de comprendre les enjeux de ses clients dans un univers de plus en plus compétitif.",
      "Auriane a plus de 20 ans d'expérience dans le Conseil et se présente comme coach orientée solutions.",
    ],
    credentials: ["ISC Bruxelles", "IGS Paris", "Coach orientée solutions"],
    languages: ["Français", "Anglais"],
  },
];

export const coachesEn = [
  {
    id: "auriane-de-potesta",
    name: "Auriane de POTESTA",
    role: "Founding Partner",
    photo: "https://lirp.cdn-website.com/514d3088/dms3rep/multi/opt/IMG-20160414-WA0000jpg.0-bc9d18ea-1920w.jpg",
    short: "Founding Partner of Audace & Perspectives.",
    bio: [
      "Founding Partner, Auriane created Audace & Perspectives in 2022. She accompanies senior executives and leaders with engagement and pragmatism in developing and optimizing their talents, in companies where client orientation and the notion of performance are increasingly important.",
      "A graduate of ISC Brussels and IGS Paris, she began her career in Brussels within Anglo-Saxon companies in commercial directions, team management, and the implementation, animation and development of distribution networks. She then joined headhunting firms, where her missions were to understand her clients' challenges in an increasingly competitive environment.",
      "Auriane has over 20 years of experience in Consulting and positions herself as a solution-oriented coach.",
    ],
    credentials: ["ISC Brussels", "IGS Paris", "Solution-oriented coach"],
    languages: ["French", "English"],
  },
];
